import PropTypes from 'prop-types';
import useInvoice from 'Hooks/useInvoice';
import { cn } from 'Utils/cn';
import useLocale from 'Hooks/useLocale';
import IconButton from 'Components/Atoms/IconButton/IconButton';
import OutlineCloseSmall from 'Components/Atoms/OutlineIcons/OutlineCloseSmall';
import InvoicesItemDescription from 'Pages/Invoices/InvoicesItemDescription';
import Skeleton from 'Components/Atoms/Skeleton/Skeleton';
import { useTranslation } from 'react-i18next';
import InvoiceAmount from 'Components/Molecules/InvoiceAmount/InvoiceAmount';
import { formatShortDate } from 'Utils/formatters';
import ReconciliationItemIcon from './ReconciliationItemIcon';

export default function ReconciliationTransactionsInvoiceAsync(props) {
    const { invoiceId, className, onDelete } = props;

    const { invoice, isLoading } = useInvoice(invoiceId);
    const locale = useLocale();
    const { t } = useTranslation('reconciliation');

    if (!invoiceId) return null;

    if (isLoading) {
        return (
            <div className="h-10 flex items-center">
                <Skeleton className="w-full max-w-sm h-5" />
            </div>
        );
    }

    if (!invoice) return null;

    return (
        <div className={cn('relative group grid grid-cols-[32px_minmax(0,1fr)_auto] items-center gap-3', className)}>
            <ReconciliationItemIcon invoice={invoice} />

            <div className="min-w-0">
                <div className="truncate text-sm font-medium text-dark-blue">
                    {invoice.invoice_party_display_name ? (
                        invoice.invoice_party_display_name
                    ) : (
                        <span className="text-gray-400">{t('no-contact')}</span>
                    )}
                </div>
                <div className="mt-0.5 truncate text-xs text-gray-500">
                    <InvoicesItemDescription invoice={invoice} />
                </div>
            </div>

            <div className="text-right whitespace-nowrap pr-9">
                <InvoiceAmount invoice={invoice} showAccountingDelivered={false} className="text-sm" />
                <div className="mt-0.5 text-xs text-gray-500">{formatShortDate(invoice.date_emission, locale)}</div>
            </div>

            {onDelete && (
                <div className="absolute top-1/2 -translate-y-1/2 right-0">
                    <IconButton
                        size="small"
                        icon={<OutlineCloseSmall />}
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete();
                        }}
                    />
                </div>
            )}
        </div>
    );
}

ReconciliationTransactionsInvoiceAsync.propTypes = {
    invoiceId: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    className: PropTypes.string,
};
